(function () {
  function initCarousel(dialog) {
    const items = Array.from(dialog.querySelectorAll('.dialog-zoomed-gallery li'));
    if (items.length < 2) return;

    // Avoid double-init
    if (dialog.dataset.carouselInit) return;
    dialog.dataset.carouselInit = 'true';

    let current = 0;

    function goTo(index) {
      items[current].classList.remove('is-active');
      current = (index + items.length) % items.length;
      items[current].classList.add('is-active');

      // Sync thumbnail strip
      const thumbs = dialog.querySelectorAll('.dialog-thumbnails-list__thumbnail');
      thumbs.forEach((t, i) => t.setAttribute('aria-selected', i === current ? 'true' : 'false'));
    }

    // Set first active
    goTo(0);

    // Inject arrow buttons
    const galleryWrapper = dialog.querySelector('.dialog-zoomed-gallery');
    const prevBtn = document.createElement('button');
    prevBtn.className = 'zoom-carousel-btn zoom-carousel-btn--prev';
    prevBtn.setAttribute('aria-label', 'Previous image');
    prevBtn.innerHTML = `<svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M15 18L9 12L15 6" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;


    prevBtn.addEventListener('click', (e) => { e.stopPropagation(); goTo(current - 1); });

    const nextBtn = document.createElement('button');
    nextBtn.className = 'zoom-carousel-btn zoom-carousel-btn--next';
    nextBtn.setAttribute('aria-label', 'Next image');
    nextBtn.innerHTML = `<svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9 6L15 12L9 18" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
    nextBtn.addEventListener('click', (e) => { e.stopPropagation(); goTo(current + 1); });

    // Append to dialog so arrows aren't clipped
    const dialogEl = dialog;
    dialogEl.style.position = 'relative';
    dialogEl.appendChild(prevBtn);
    dialogEl.appendChild(nextBtn);


    // Wire thumbnail clicks to carousel
    const thumbs = dialog.querySelectorAll('.dialog-thumbnails-list__thumbnail');
    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => goTo(i), { capture: true });
    });

    // Keyboard navigation
    dialog.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') goTo(current + 1);
      if (e.key === 'ArrowLeft') goTo(current - 1);
    });
  }

  // Watch for the dialog opening (it's injected dynamically)
  const observer = new MutationObserver(() => {
    const dialogs = document.querySelectorAll('zoom-dialog dialog');
    dialogs.forEach(initCarousel);
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
